export const LIVE = 'live';
export const FINISHED = 'finished';
export const NOT_STARTED = 'not_started';
export const INTERRUPTED = 'interrupted';
export const CANCELLED = 'cancelled';
export const UPCOMING = 'not_started';
export const ALL = 'ALL';

export const statusFilters = [ALL, FINISHED, NOT_STARTED, LIVE, INTERRUPTED, CANCELLED, UPCOMING] as const;
